import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import { environment } from "~env";
import { MemberInsuranceViewModel, SubscriptionFormViewModel, SubscriptionPeriod, SubscriptionProlongationViewModel } from "./subscription.model";

@Injectable({
  providedIn: "root"
})
export class SubscriptionQueryService {
  private QUERY_API = environment.farpQueryApi;
  private PAYMENT_API = environment.registrarPaymentApi;
  private PROJECTION_QUERY_API = environment.projectionQueryApi;

  constructor(
    private http: HttpClient,
  ) {}

  //note: this is only to easily test the payments without going to Moneris
  //which is slow and sometimes crash (moneris side), we should remove this after testing
  allowByPassMoneris(): boolean {
    var localHostName =  window.location.hostname.toLowerCase();
    var localHostOrDev = localHostName== "localhost" || localHostName.indexOf("-dev")>0 || localHostName.indexOf("-uat")>0;
    return localHostOrDev;
  }

  //need only in the primes table, so it can fit in a small screen
  isMobile(): boolean {
   return window.navigator['userAgentData']?.mobile??false;
  }

  getSubscriptionForm(periodId: string, subscriptionNoticeId: string, memberId): Observable<SubscriptionFormViewModel> {

    let URL = `${this.QUERY_API}/Subscription/Form/${memberId}/${periodId}/GetData`;
    if (subscriptionNoticeId) {
      URL += `?subscriptionNoticeId=${subscriptionNoticeId}`;
    }
    return this.http.get<SubscriptionFormViewModel>(URL);
  }
  
  getPeriods(memberId: string): Observable<SubscriptionPeriod[]> {
    const URL = `${this.QUERY_API}/Subscription/Member/${memberId}/GetPeriodsForSubscription`;
    return this.http.get<SubscriptionPeriod[]>(URL);
  }

  getSubscriptionProlongation(permitNumber: string): Observable<SubscriptionProlongationViewModel> {
    return this.getMemberIdByPermitNumber(permitNumber)
    .pipe(
      switchMap((memberId) =>  {
       const URL = `${this.QUERY_API}/Subscription/Member/${memberId}/GetSubscriptionProlongation`;
      return this.http.get<SubscriptionProlongationViewModel>(URL);  
      })  
    );
  }

  getSubscriptionStatus(memberId: string): Observable<MemberInsuranceViewModel[]> {
    const URL = `${this.QUERY_API}/Subscription/${memberId}/GetSubscriptionStatus`;
    return this.http
      .get<MemberInsuranceViewModel[]>(URL)
      .pipe(map((res) => res));;
  }

  getMemberIdByPermitNumber(permitNumber: string): Observable<string> {
    const URL = `${this.PROJECTION_QUERY_API}/fullMembers?$select=Id&?$filter=PermitNumber eq ${permitNumber}`;
    return this.http.get<any>(URL).pipe(
      map(res => res['value'][0].Id)
    );
  }

  public getParticularConditionReport(
    memberId: string,
    fiscalYear: number
  ): Observable<any> {
    const endpoint = `${this.QUERY_API}/SubscriptionReport/Member/${memberId}/${fiscalYear}/GetParticularConditionsReport`;
    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/pdf');

    return this.http.get(endpoint, {
      headers: headers,
      responseType: 'blob' as 'json'
    });
  }

  public getSubscriptionReceipt(
    memberId: string,
    id: string
  ): Observable<any> {
    const endpoint = `${this.QUERY_API}/SubscriptionReport/Member/${memberId}/${id}/GetSubscriptionReceiptReport`;
    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/pdf');

    return this.http.get(endpoint, {
      headers: headers,
      responseType: 'blob' as 'json'
    });
  }
}
